module.exports = __webpack_public_path__ + "static/media/nzlogowhite.149ed8d4.png";